module.exports = __webpack_public_path__ + "static/img/map-768x432.5154f554.png";